/**
 * api/sync.js - Frontend API for background sync operations.
 */

import axios from "axios";
import { API_BASE } from "../config.js";
import { getAccessToken } from "../auth/apiAuth.jsx";

const api = axios.create({
  baseURL: `${API_BASE}/api/data/sync`,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const tk = getAccessToken && getAccessToken();
  if (tk) config.headers.Authorization = `Bearer ${tk}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      let msg =
        data?.error?.message ||
        (typeof data?.error === "string" ? data.error : null) ||
        data?.detail ||
        data?.message ||
        "Unknown error";
      const e = new Error(msg);
      e.status = status;
      e.details = data;
      if (status === 401) e.message = "Your session has expired. Please sign in again.";
      return Promise.reject(e);
    }
    return Promise.reject(error);
  }
);

/**
 * Trigger a background sync. Returns immediately.
 * @param {string} [company] - Optional company name to sync only that branch
 */
export async function startSync(company) {
  const response = await api.post("/start", company ? { company } : {});
  return response.data;
}

/**
 * Get current sync status.
 */
export async function getSyncStatus() {
  const response = await api.get("/status");
  return response.data;
}
